import { render, staticRenderFns } from "./SalesPeriod.vue?vue&type=template&id=14809187&"
import script from "./SalesPeriod.vue?vue&type=script&lang=ts&"
export * from "./SalesPeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports